import { resolvePACORemote } from './utilities/remoteResolver';

window.MfRemote = resolvePACORemote();
/**
 * the entry point mainly serve customer ONLY
 * you can change to agent's view by adding ?target=agents in url
 */
import('./bootstrap.customer').then((mod) => {
  return import('./setup-app').then(async ({ setup }) => {
    const { APP_TARGE, STORAGE_KEY } = await import('./constants');
    localStorage.setItem(STORAGE_KEY, APP_TARGE.CUSTOMER);
    localStorage.setItem(`theme:${APP_TARGE.CUSTOMER}`, 'light');
    return setup(mod);
  });
});
